module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup', {
    staticClass: "contract-wrap",
    attrs: {
      "height": "100%"
    },
    model: {
      value: (_vm.contractPopup.isShowContract),
      callback: function($$v) {
        _vm.$set(_vm.contractPopup, "isShowContract", $$v)
      },
      expression: "contractPopup.isShowContract"
    }
  }, [_c('header', [_c('div', {
    staticClass: "closeContract block_v",
    on: {
      "click": _vm.closeContract
    }
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-close-outline block_vc",
    attrs: {
      "type": "ios-close-outline",
      "size": "30",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M340.2 160l-84.4 84.2-84-83.8-11.8 11.8 84 83.8-84 83.8 11.8 11.8 84-83.8 84.4 84.2 11.8-11.8-84.4-84.2 84.4-84.2z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contract-title"
  }, [_vm._v("\n        " + _vm._s(_vm.contractPopup.contractTitle) + "\n      ")])]), _vm._v(" "), (_vm.contractPopup.contractContent) ? _c('section', {
    style: ({
      height: _vm.contentHeight
    }),
    attrs: {
      "id": "content-style"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contractPopup.contractContent)
    }
  }, [_c('div')]) : _vm._e(), _vm._v(" "), (_vm.contractPopup.imgSrc) ? _c('div', {
    staticStyle: {
      "margin": "1.2rem 0.2rem 0.8rem",
      "position": "relative"
    },
    style: ({
      height: _vm.contractPopup.contentHeight
    })
  }, [_c('div', {
    staticClass: "overScroll_main"
  }, [_c('div', {
    staticClass: "scroll_maiLabel hetongPdfs"
  }, [_c('iframe', {
    attrs: {
      "src": '../../static/pdf/web/viewer.html?file=' + _vm.url
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.contractPopup.isShowSign) ? _c('div', {
    staticClass: "sign"
  }, [(_vm.signBtn.isShow) ? _c('x-button', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "warn",
      "action-type": "button",
      "disabled": _vm.signBtn.state
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signContract.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.signBtn.text))]) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7314f26d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contractPopup.vue
// module id = 553
// module chunks = 88